export const CURRENCY = {
  USD: 'USD',
  EUR: 'EUR',
  RUB: 'RUB',
}

export const CURRENCY_SIGN = {
  [CURRENCY.USD]: '$',
}
